import React from 'react';

/**
 * EmptyState - A reusable component for empty/placeholder states
 * 
 * @param {string} icon - Emoji or icon to display (default: '📭')
 * @param {string} title - Main heading text
 * @param {string} description - Secondary description text
 * @param {React.ReactNode} action - Optional action button/element
 * @param {React.ReactNode} footer - Optional footer content (tips, additional info)
 * @param {string} className - Additional CSS classes for the container
 */
const EmptyState = ({ 
  icon = '📭', 
  title, 
  description, 
  action,
  footer,
  className = ''
}) => {
  return (
    <div className={`flex flex-col items-center justify-center py-16 px-4 text-center ${className}`} data-testid="empty-state">
      <div className="text-6xl mb-4" data-testid="empty-state-icon">{icon}</div>
      {title && (
        <h2 className="text-xl font-semibold text-gray-700 mb-2" data-testid="empty-state-title">
          {title}
        </h2>
      )}
      {description && (
        <p className="text-gray-500 max-w-sm mx-auto mb-6" data-testid="empty-state-description">
          {description}
        </p>
      )}
      {action && (
        <div data-testid="empty-state-action">
          {action}
        </div>
      )}
      {footer && (
        <div className="mt-4" data-testid="empty-state-footer">
          {footer}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
